export const maxCookies = 1000;
export const maxKnowledgeMechanics = 20;
export const runningTimePerRound = 40;
export const runningTimePerAsset = {
    mixer: 38,
    vormmachineA: 18,
    vormmachineB: 18,
    oven: 30,
    koeler: 34,
    inpakker: 40,
};
export const downtimePerAsset = {
    mixer: { storing: 16, incident: 24, onderhoud: 10 },
    vormmachineA: { storing: 20, incident: 22, onderhoud: 14 },
    vormmachineB: { storing: 20, incident: 25, onderhoud: 14 },
    oven: { storing: 18, incident: 20, onderhoud: 10 },
    koeler: { storing: 22, incident: 20, onderhoud: 12 },
    inpakker: { storing: 24, incident: 22, onderhoud: 16 },
};
// Opmerkingen uit het origineel:
// deliveryTimePerPart.eMotor = 12;
// positiesensor -> in sheet but not on tasks
// kneedhaken -> in sheet but not on tasks
//   infraroodCamera = "infraroodCamera", -> on tasks but not in sheet
export const deliveryTimePerPart = {
    aandrijving: 8,
    flexpicker: 7,
    meelDoseerder: 16,
    luchtfilters: 11,
    thermostaat: 6,
    vacuumGripper: 14,
    verwarmingselement: 13,
    deegwals: 15,
    watertoevoerklep: 9,
    doorvoerband: 6,
};
export const totalChipsNeededForMalfunction = {
    mixer: 3,
    vormmachineA: 2,
    vormmachineB: 4,
    oven: 2,
    koeler: 2,
    inpakker: 4,
};
